/* 发布订阅标准事件名 - start */ 
const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    videoPlay: 'jky-video-paly'
};
/* 发布订阅标准事件名 - end */ 


/* 全局发布订阅事件管理 - start */ 
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) { subscribers[eventName] = []; }
  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {return cb !== callback;});
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {callback(data);});
  }
}
/* 全局发布订阅事件管理 - end */ 


/* 通用Fetch - start */
function fetchConfig(method = 'POST') {
    return {
        method,
        headers: { 
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json', 
            Accept: `application/json`,
            cr: pageInfo?.cr || 'US',
            lang: pageInfo?.lang || 'en'
        }
    };
} 

function formatFetchUrl(url = '') {
    let _url = '';
    switch (pageInfo?.env) {
        case 'prod':
            _url = 'https://api.myjackery.com';
            break;
        case 'uat':
            _url = 'https://api-uat.myjackery.com';
            break;
        case 'demo':
            _url = 'https://demo-api.myjackery.com';
            break;
        default:
            _url = 'https://api.myjackery.com';
            break;
    }
    return _url;
}
/* 通用Fetch - end */ 


/* common utils - start */ 
function getUrlQueryParams(key = '') {
    if (typeof location === 'undefined') {
      console.error('getUrlQueryParams Error: location object is not available.');
      return key ? undefined : {};
    }
    const searchParams = new URLSearchParams(location.search);
    const res = {};
    for (const [k, v] of searchParams.entries()) {
      res[k] = v;
    }
    return key ? res[key] : res;
}

function debounce(func, wait = 100) {
let timeout;
return function(...args) {
    clearTimeout(timeout),
    timeout = setTimeout( () => func.apply(this, args), wait);
}
}

function throttle(fn, delay) {
let timer;
return function () {
    if (!timer) {
    timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
    }, delay);
    }
}
}

function formatMoney(cents, format) {
if (typeof cents === 'string') {
    cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
var formatString = format || window?.pageInfo?.currency?.money_format;

function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
    return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
}

switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
    value = formatWithDelimiters(cents, 2);
    break;
    case 'amount_no_decimals':
    value = formatWithDelimiters(cents, 0);
    break;
    case 'amount_with_comma_separator':
    value = formatWithDelimiters(cents, 2, '.', ',');
    break;
    case 'amount_no_decimals_with_comma_separator':
    value = formatWithDelimiters(cents, 0, '.', ',');
    break;
}

return formatString.replace(placeholderRegex, value);
}

function copyString (value, cb) {
    const textarea = document.createElement('textarea');
    textarea.readOnly = 'readonly';
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('Copy');
    document.body.removeChild(textarea);
    cb && cb();
}

/**
 * 验证邮箱格式
 * @param email 邮箱地址
 * @returns 返回验证结果
 */
 function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9]+([._%+-][a-zA-Z0-9]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

function getAbsoluteTop(element) {
if (!element) return 0;
const rect = element.getBoundingClientRect();
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
return rect.top + scrollTop;
}

// 判断元素是否正常显示
function isElementVisible(element) {
if (!element || !document.body.contains(element)) {
    return false;
}

let current = element;
do {
    const style = window.getComputedStyle(current);
    if (style.display === 'none') {
        return false;
    }
    current = current.parentElement;
} while (current);

return !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
);
}
/* common utils - end */ 


/* ga Function - start */ 
function handleGaEvents(doc = document) {
    const gaElts = doc.querySelectorAll("[data-ga-event]");
    if (gaElts.length === 0) return;
    [...gaElts].map((elt) => {
        try {
            const evtType = elt.getAttribute("data-ga-action")
            const evtName = elt.getAttribute("data-ga-event")
            if (!evtType) return
            if (!evtName) return

            function handleGA(evt) {
                evt.stopPropagation();

                if(!evt.isTrusted) return
                const target = $(this)[0]
                let url = '';
                if (target.getAttribute("data-href")) {
                    // evt.preventDefault();
                    url = target.getAttribute("data-href");
                }
                let params = {}
                const attributeNames = target.getAttributeNames();

                attributeNames.forEach(attribute => {
                    if(attribute.indexOf("data-ga-params-") === 0) {
                        const key = attribute.replace("data-ga-params-", "")
                        params[key] = target.getAttribute(attribute)
                    }
                });
                    
                window.dataLayer.push({ event_parameters: null });
                window.dataLayer.push({
                    event: "ga4Event",
                    event_name: evtName,
                    event_parameters: {
                        current_page: window.location.href,
                        ...params
                    }
                });

                elt.setAttribute("ga-loaded", true)

                setTimeout(function() {
                    if (url) {
                        if(target.getAttribute("target") === "_blank") {
                            window.open(url, "_blank");
                        } else {
                            window.location.href = url
                        }
                    }
                }, 40)
            }

            if(elt.getAttribute("ga-loaded")) return
            elt.removeEventListener(evtType, handleGA)
            elt.addEventListener(evtType, handleGA)
        } catch (e) {
            console.log(
                "Something wrong happened when setting up event handling for ga4Events."
            );
        }
    });
}
/* ga Function - end */ 